export default "__VITE_ASSET__2cea0894__"